import React, { useEffect, useRef, useState } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  ChevronUp,
  Download,
  File,
  Filter,
  Sliders,
  StopCircle,
  Archive,
  User,
  Calendar,
  Layers,
  FileMinus,
  RotateCcw,
} from "feather-icons-react/build/IconComponents";
import Select from "react-select";
import {
  exportPDF,
  exportExcel,
  HandlePrint,
  renderTooltip,
} from "../../../redux/helper";
import { Table } from "antd";
import { purchaseslist } from "../../../core/json/purchaselistdata";
import { setheadertoggle } from "../../../redux/toggle";
import { useDispatch, useSelector } from "react-redux";
import {
  getitemWiseSalesReport,
  getSalesReport,
} from "../../../services/ReportApiService";
import {
  fetchUnit,
  fetchProduct,
  fetchTax,
  fetchSettings,
  fetchCustomer,
} from "../../../redux/userSetting";
import {
  DatatablePagingParameter,
  Filterclass,
} from "../../../core/json/DatatablePagingParameters";

import * as XLSX from "xlsx";
import { Checkbox } from "antd";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { DatePicker } from "antd";
// import "react-datepicker/dist/react-datepicker.css";
import dayjs from "dayjs";
import {
  fetchCategory,
  fetchCounter,
  fetchSection,
  fetchUserRole,
} from "../../../redux/userSetting";
import { fetchUser } from "../../../redux/userServices";
import {
  exportreportExcel,
  exportreportPDF,
  printreportReport,
} from "../../../core/utils/MainReportUtils";
import LoadingUtils from "../../../core/utils/LoadingUtils";

const ItemWiseSale = () => {
  const purchasedata = purchaseslist;
  const [searchText, setSearchText] = useState("");
  const [salesData, setsalesData] = useState();
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [loading, setloading] = useState(false);
  const [fromDate, setFromDate] = useState(dayjs());
  const [toDate, setToDate] = useState(dayjs());
  const [totalcount, settotalcount] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [waiter, setwaiter] = useState();
  const [counterval, setcounterval] = useState();
  const [sectionval, setsectionval] = useState();
  const [productval, setproductval] = useState();
  const [categoryval, setscategoryval] = useState();

 
  const [allData, setallData] = useState();
  const dispatch = useDispatch();
  const { branch } = useSelector((state) => state.branchlist);
  const { togglehead } = useSelector((state) => state.headerToggle);
  const { userRoles, counterList, sectionList, productList, categoryList } =
    useSelector((state) => state.usersetting);
  const { UserList } = useSelector((state) => state.userservice);
  const { companyInfolist } = useSelector((state) => state.companyInfo);
  const tableRef = useRef(null);
  const filteredData = purchasedata?.filter((entry) => {
    return Object.keys(entry).some((key) => {
      return String(entry[key])
        .toLowerCase()
        .includes(searchText.toLowerCase());
    });
  });
  useEffect(() => {
    handlegetsalesReport(currentPage, pageSize);
    handlegetsalesfullReport();
    dispatch(fetchSection(branch.guid));
    dispatch(fetchCounter(branch.guid));
    dispatch(fetchProduct(branch));
    dispatch(fetchCategory(branch.guid));
    dispatch(fetchUser());
    dispatch(fetchUnit());
    dispatch(fetchProduct(branch));
    dispatch(fetchTax());
   // dispatch(fetchSettings(branch));

  
  }, [branch, fromDate, toDate]);
  const currfmt = useSelector((state) => {
    const match = state.usersetting?.settingList?.currencyFormat?.toString()?.match(/\.0+/);
    return match ? match[0]?.length - 1 : 0;
  });
  const handlegetsalesReport = async (page, size) => {
    const DatatablePagingParameters = new DatatablePagingParameter();
    DatatablePagingParameters.PageNumber = page;
    DatatablePagingParameters.PageSize = size;
    const formattedfromDate = dayjs(fromDate).format("YYYY-MM-DD");
    const formattedtoDate = dayjs(toDate).format("YYYY-MM-DD");
    const Filters = new Filterclass();
    Filters.Branch = branch;
    Filters.FromDate = formattedfromDate;
    Filters.ToDate = formattedtoDate;
    try {
      const response = await getitemWiseSalesReport({
        DatatablePagingParameters,
        Filters,
      });
      console.log("eeeeeeeeeeeeee",response?.data?.itemWiseSalesReportDetail);
      setsalesData(response?.data?.itemWiseSalesReportDetail);
      settotalcount(
        response?.data?.itemWiseSalesReportDetail[0]?.recordsFilteredCount
      );
    } catch (error) {
      console.error(
        "Error Fetching Account Type!",
        error.response.data.Message
      );
    }
  };
  const handlegetsalesfullReport = async () => {
    setloading(true);
    const DatatablePagingParameters = new DatatablePagingParameter();
    DatatablePagingParameters.PageNumber = 1;
    DatatablePagingParameters.PageSize = -1;
    const formattedfromDate = dayjs(fromDate).format("YYYY-MM-DD");
    const formattedtoDate = dayjs(toDate).format("YYYY-MM-DD");
    const Filters = new Filterclass();
    Filters.Branch = branch;
    Filters.FromDate = formattedfromDate;
    Filters.ToDate = formattedtoDate;
    try {
      const response = await getitemWiseSalesReport({
        DatatablePagingParameters,
        Filters,
      });
      setloading(false);
      console.log("itemwisesale",response?.data?.itemWiseSalesReportDetail);

      
      setallData(response?.data?.itemWiseSalesReportDetail);
    } catch (error) {
      setloading(false);
      console.error(
        "Error Fetching Account Type!",
        error.response.data.Message
      );
    }
  };
  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };
  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const exportToPDF = () => {
    const pdf = new jsPDF("p", "mm", "a4");
    const tableRef1 = document.getElementById("table-to-export");

    html2canvas(tableRef1).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const imgWidth = 190; // Width in PDF
      const pageHeight = 295; // Height for A4
      const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio
      let heightLeft = imgHeight;
      let position = 10;

      pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save("Sales_Report.pdf");
    });
  };

  const menuItems = [
    { value: "1", label: "Bill Date", checked: true },
    { value: "2", label: "Bill No", checked: true },
    { value: "3", label: "Product", checked: true },
    { value: "4", label: "Quantity", checked: true },
    { value: "5", label: "Rate", checked: true },
    { value: "6", label: "Tax %", checked: false },
    { value: "7", label: "Vat Amount", checked: false },
    { value: "8", label: "Tax Amount", checked: false },
    { value: "9", label: "CGST", checked: false },
    { value: "10", label: "SGST", checked: false },
    { value: "11", label: "Discount", checked: false },
    { value: "12", label: "Tota", checked: true },
    { value: "13", label: "Counter", checked: false },
    { value: "14", label: "Section", checked: false },
    { value: "15", label: "Waiter", checked: false },
  ];

  const columns = [
    {
      title: "Bill Date",
      key: "1",
      dataIndex: "billDate",
      render: (text) => {
        const formatDate = (dateString) => {
          const date = new Date(dateString);
          return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          });
        };

        return <span>{formatDate(text)}</span>;
      },
    },

    {
      title: "Bill No",
      key: "2",
      dataIndex: "billNo",
      sorter: (a, b) => a.billNo - b.billNo,
    },
    {
      title: "Product",
      key: "3",
      dataIndex: "product",
      render: (text) => <span>{text.name}</span>,
      sorter: (a, b) => a.product?.name?.length - b.product?.name?.length,
    },

    {
      title: "Quantity",
      key: "4",
      dataIndex: "quantity",
      sorter: (a, b) => a.quantity - b.quantity,
    },
    {
      title: "Rate",
      key: "5",
      dataIndex: "rate",
      sorter: (a, b) => a.rate - b.rate,
    },
    {
      title: "Tax %",
      key: "6",
      dataIndex: "taxPercentage",
      sorter: (a, b) => a.taxPercentage - b.taxPercentage,
    },
    {
      title: "Vat Amount",
      key: "7",
      dataIndex: "vatAmount",
      sorter: (a, b) => a.vatAmount - b.vatAmount,
    },
    {
      title: "Tax Amount",
      key: "8",
      dataIndex: "taxAmount",
      sorter: (a, b) => a.taxAmount - b.taxAmount,
    },
    {
      title: "CGST",
      key: "9",
      dataIndex: "cgst",
      sorter: (a, b) => a.cgst - b.cgst,
    },
    {
      title: "SGST",
      key: "10",
      dataIndex: "sgst",
      sorter: (a, b) => a.sgst - b.sgst,
    },
    {
      title: "Discount",
      key: "11",
      dataIndex: "discount",
      sorter: (a, b) => a.discount - b.discount,
    },

    {
      title: "Total",
      key: "12",
      dataIndex: "total",
      sorter: (a, b) => a.total - b.total,
    },

    {
      title: "Counter",
      key: "13",
      dataIndex: "counter",
      render: (text) => <span>{text.name}</span>,
      sorter: (a, b) => a.counter?.name?.length - b.counter?.name?.length,
    },

    {
      title: "Section",
      key: "14",
      dataIndex: "section",
      render: (text) => <span>{text.name}</span>,
      sorter: (a, b) => a.section?.name?.length - b.section?.name?.length,
    },
    {
      title: "Waiter",
      key: "15",
      dataIndex: "user",
      render: (text) => <span>{text.name}</span>,
      sorter: (a, b) => a.user?.name?.length - b.user?.name?.length,
    },
  ];

  const [selectedColumns, setSelectedColumns] = useState();

  useEffect(() => {
    // Set default selected columns based on menuItems' checked status
    const initialSelectedColumns = menuItems
      ?.filter((item) => item.checked)
      ?.map((item) => columns?.find((col) => col.key === item.value));

    setSelectedColumns(initialSelectedColumns);
  }, []);

  const handleCheckboxChange = (columnKey, checked) => {
    if (checked) {
      // Add column if checkbox is checked
      setSelectedColumns((prevColumns) => {
        const updatedColumns = [
          ...prevColumns,
          columns?.find((col) => col.key === columnKey),
        ];

        // Sort the array by col.key in ascending order
        return updatedColumns.sort((a, b) => (a.key > b.key ? 1 : -1));
      });
    } else {
      // Remove column if checkbox is unchecked
      setSelectedColumns((prevColumns) =>
        prevColumns?.filter((col) => col.key !== columnKey)
      );
    }
  };

  const handletogglehead = () => {
    dispatch(setheadertoggle(!togglehead));
  };
  const handleFromDateChange = (date) => {
    console.log(date, "from date");
    setFromDate(date);

    setToDate(null); // reset to date when from date changes
  };
  const handleToDateChange = (date) => {
    setToDate(date);
    console.log(date, "to date");
  };
  const userroles = UserList?.map((e) => ({
    value: e.guid,
    label: e.name,
  }));
  const counter = counterList?.map((e) => ({
    value: e.guid,
    label: e.name,
  }));
  const section = sectionList?.map((e) => ({
    value: e.guid,
    label: e.name,
  }));
  const product = productList?.map((e) => ({
    value: e.guid,
    label: e.name,
  }));
  const category = categoryList?.map((e) => ({
    value: e.guid,
    label: e.name,
  }));
  const modifiedList = salesData?.filter((obj) => {
    const searchMatch =
      obj.billNo?.toLowerCase().includes(searchText?.toLowerCase()) ||
      obj.product.name?.toLowerCase().includes(searchText?.toLowerCase()) ||
      obj.counter.name?.toLowerCase().includes(searchText?.toLowerCase()) ||
      obj.user.name?.toLowerCase().includes(searchText?.toLowerCase()) ||
      obj.section.name?.toLowerCase().includes(searchText?.toLowerCase());
    const productmatch = !productval || obj?.product?.name == productval?.label;
    const cashierMatch = !waiter || obj?.user?.name == waiter?.label;
    const counterMatch = !counterval || obj?.counter?.name == counterval?.label;
    const sectionMatch = !sectionval || obj?.section?.name == sectionval?.label;

    return (
      searchMatch &&
      productmatch &&
      cashierMatch &&
      counterMatch &&
      sectionMatch
    );
  });
  const modifiedallList = allData?.filter((obj) => {
    const searchMatch =
      obj.billNo?.toLowerCase().includes(searchText?.toLowerCase()) ||
      obj.product.name?.toLowerCase().includes(searchText?.toLowerCase()) ||
      obj.counter.name?.toLowerCase().includes(searchText?.toLowerCase()) ||
      obj.user.name?.toLowerCase().includes(searchText?.toLowerCase()) ||
      obj.section.name?.toLowerCase().includes(searchText?.toLowerCase());
    const productmatch = !productval || obj?.product?.name == productval?.label;
    const cashierMatch = !waiter || obj?.counter?.name == waiter?.label;
    const counterMatch = !counterval || obj?.counter?.name == counterval?.label;
    const sectionMatch = !sectionval || obj?.section?.name == sectionval?.label;

    return (
      searchMatch &&
      productmatch &&
      cashierMatch &&
      counterMatch &&
      sectionMatch
    );
  });
  const getActiveTabData = () => {
    let fieldMapping = {};

    // Function to create the field mapping between column titles and dataIndex values
    const createfieldMapping = (columns) => {
      const mappings = {};
      columns.forEach((col) => {
        mappings[col.title] = col.dataIndex; // Map title to dataIndex
      });
      return mappings;
    };

    // Generate the field mapping for the current columns
    fieldMapping = createfieldMapping(columns);

    console.log("fieldMapping of first table:", fieldMapping);
    console.log("salesData of  table:", allData);

    // Return the filtered data, columns, and field mapping
    return { data: modifiedallList, columns: selectedColumns, fieldMapping, Rname:"ItemWise Sale Report" };
  };

  const totalPrice = allData?.reduce((sum, record) => sum + (record.total-record.discount), 0);
  console.log("object",totalPrice)
  const footerTotals = {
    total: totalPrice?.toFixed(currfmt),
  };
  const handleReset = () => {
    setFromDate((prev) => dayjs());
    setToDate((prev) => dayjs());
    setSearchText("");
    setwaiter("");
    setcounterval("");
    setsectionval("");
    // handlegetsalesfullReport();
    // handlegetsalesReport(currentPage, pageSize);
  };
  const handleRefresh = () => {
    handlegetsalesReport(currentPage, pageSize);
      handlegetsalesfullReport();
    };
  return (
    <div>
      <LoadingUtils loading={loading} />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Item Wise Sales Report</h4>
              </div>
            </div>

            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip("PDF")}>
                  <button
                    onClick={() =>
                      exportreportPDF(getActiveTabData,footerTotals,companyInfolist)
                    }
                    disabled={loading}
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Excel")}
                >
                  <button
                    onClick={() =>
                      exportreportExcel(
                        getActiveTabData,
                        footerTotals,companyInfolist
                      )
                    }
                    disabled={loading}
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="excel-icon"
                    />
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Print")}
                >
                  <button
                    onClick={() =>
                      printreportReport(
                        getActiveTabData,
                        footerTotals,companyInfolist
                      )
                    }
                    disabled={loading}
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <i data-feather="printer" className="feather-printer" />
                  </button>
                </OverlayTrigger>
              </li>
               <li>
                              <OverlayTrigger
                                placement="top"
                                overlay={() => renderTooltip("Refresh")}
                              >
                                <Link onClick={handleRefresh}>
                                  <RotateCcw/>
                                </Link>
                              </OverlayTrigger>
                            </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Collapse")}
                >
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={togglehead ? "active" : ""}
                    onClick={handletogglehead}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>

          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set mt-2">
                  <div className="search-input">
                    <Link to="#" className="btn btn-searchset">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-search"
                      >
                        <circle cx={11} cy={11} r={8} />
                        <line x1={21} y1={21} x2="16.65" y2="16.65" />
                      </svg>
                    </Link>
                    <div
                      id="DataTables_Table_0_filter"
                      className="dataTables_filter"
                    >
                      <label>
                        {" "}
                        <input
                          type="search"
                          className="form-control form-control-sm"
                          placeholder="Search"
                          aria-controls="DataTables_Table_0"
                          value={searchText}
                          onChange={handleSearch}
                        />
                      </label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="input-blocks">
                      <label htmlFor="from-date">From Date</label>
                      <div className="input-groupicon calender-input">
                        <Calendar className="info-img" />
                        <DatePicker
                          className="datetimepicker"
                          id="from-date"
                          placeholderText="From Date"
                          // selected={fromDate}
                          value={fromDate}
                          onChange={handleFromDateChange}
                          startDate={fromDate}
                          selectsStart
                          // dateFormat="dd/MM/yyyy"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-blocks mr-2">
                      <label htmlFor="to-date">To Date</label>
                      <div className="input-groupicon calender-input">
                        <Calendar className="info-img" />
                        <DatePicker
                          id="to-date"
                          placeholderText="To Date"
                          // selected={toDate}
                          value={toDate}
                          onChange={handleToDateChange}
                          minDate={fromDate}
                          startDate={fromDate}
                          selectsEnd
                          disabled={!fromDate} // disable until from date is selected
                          // dateFormat="dd/MM/yyyy"
                          // className='form-control'
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-end mt-4">
                  <div className="input-blocks me-2">
                    <Link
                      className="btn btn-filters ms-auto"
                      onClick={() => {
                        setCurrentPage(1);
                        setPageSize(20);
                        handlegetsalesfullReport();
                        handlegetsalesReport(currentPage, pageSize);
                      }}
                    >
                      <i data-feather="search" className="feather-search" />{" "}
                      search{" "}
                    </Link>
                  </div>
                  <div className="input-blocks">
                    <button
                      className="btn btn-reset rounded-2"
                      onClick={handleReset}
                    >
                      <i
                        data-feather="refresh-cw"
                        className="feather-refresh-cw"
                      />{" "}
                      Reset
                    </button>
                  </div>
                </div>
                <div className="search-path">
                  <Link
                    className={`btn btn-filter ${
                      isFilterVisible ? "setclose" : ""
                    }`}
                    id="filter_search"
                    onClick={toggleFilterVisibility}
                  >
                    <Filter className="filter-icon" />
                    <span onClick={toggleFilterVisibility}>
                      <ImageWithBasePath
                        src="assets/img/icons/closes.svg"
                        alt="img"
                      />
                    </span>
                  </Link>
                </div>

                <div className="dropdown">
                  <button
                    className="btn  dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <Sliders className="info-img" />
                  </button>
                  <ul className="dropdown-menu p-2">
                    {menuItems?.map((obj, i) => {
                      return (
                        <li key={i}>
                          <Checkbox
                            onChange={(e) =>
                              handleCheckboxChange(obj.value, e.target.checked)
                            }
                            defaultChecked={obj.checked}
                          >
                            <div style={{ color: "black" }}> {obj.label}</div>
                          </Checkbox>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>

              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="card-body pb-0">
                  <div className="row">
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <Layers className="info-img" />
                        <Select
                          className="img-select"
                          options={product}
                          value={productval}
                          onChange={setproductval}
                          isClearable
                          classNamePrefix="react-select"
                          placeholder="Enter Product"
                        />
                      </div>
                    </div>
                    {/* <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <FileMinus className="info-img" />
                        <Select
                          className="img-select"
                          options={category}
                          value={categoryval}
                          onChange={setscategoryval}
                          isClearable
                          classNamePrefix="react-select"
                          placeholder="Enter Category"
                        />
                      </div>
                    </div> */}
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <File className="info-img" />
                        <Select
                          className="img-select"
                          options={section}
                          value={sectionval}
                          onChange={setsectionval}
                          isClearable
                          classNamePrefix="react-select"
                          placeholder="Enter Section"
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <Archive className="info-img" />
                        <Select
                          className="img-select"
                          options={counter}
                          value={counterval}
                          onChange={setcounterval}
                          isClearable
                          classNamePrefix="react-select"
                          placeholder="Enter Counter"
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <User className="info-img" />
                        <Select
                          className="img-select"
                          options={userroles}
                          value={waiter}
                          onChange={setwaiter}
                          isClearable
                          classNamePrefix="react-select"
                          placeholder="Enter Waiter"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* /Filter */}
              {selectedColumns && (
                <div className="table-responsive product-list">
                  <Table
                    className="table datanew dataTable no-footer custom-table"
                    columns={selectedColumns}
                    dataSource={modifiedList}
                    ref={tableRef}
                    id="table-to-export"
                    pagination={{
                      showTotal: (total, range) =>
                        `${range[0]}-${range[1]} of ${totalcount} items`,
                      current: currentPage,
                      pageSize: pageSize,
                      total: totalcount, // Total records count
                      onChange: (page, size) => {
                        setCurrentPage(page);
                        setPageSize(size);
                        handlegetsalesReport(page, size);
                      },
                      showSizeChanger: true, // To enable page size selection dropdown
                      pageSizeOptions: ["10", "20", "50", "100"], // Different page size options
                    }}
                    summary={() => (
                      <Table.Summary.Row>
                        {selectedColumns?.map((col) => (
                          <Table.Summary.Cell key={col.dataIndex}>
                            <b>{footerTotals[col.dataIndex] || ""}</b>
                          </Table.Summary.Cell>
                        ))}
                      </Table.Summary.Row>
                    )}
                  />
                </div>
              )}
            </div>
            <div className="footerComment ml-3"> <b>* Please be informed that there will be a difference between the item-wise sales report and other sales reports if a bill-wise discount is applied.</b></div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ItemWiseSale;
